import {api} from "../../../system/api";
import {PREFIX_URL} from "../../../system/api/constants";

export default {
    getTypes: project_id => api.get(PREFIX_URL.PROJECT + `/${project_id}/ticket-types`),
    updateType: (typeId, params) => api.put(`/ticket-types/${typeId}`, params),
    updatePosition: (project_id, params) => api.put(PREFIX_URL.PROJECT + `/${project_id}/ticket-types/positions`, params),
    createType: (projectId, params) => api.post(`/projects/${projectId}/ticket-types`, params),
}
